module.exports = __webpack_public_path__ + "static/media/ee.3e08e4d9.svg";